import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';
export const useMutation = (key, promise) => {
    const { mutate } = useSWRConfig();
    const { trigger: SWRTrigger, isMutating } = useSWRMutation(key, async (_, { arg }) => {
        return promise(arg);
    });
    return {
        isMutating,
        trigger: (arg, opts) => {
            // TODO: watch SWR updates to see if types are fixed
            const data = SWRTrigger(arg, {
                populateCache: (opts === null || opts === void 0 ? void 0 : opts.populateCache)
                    ? (result, currentData) => { var _a; return (_a = opts.populateCache) === null || _a === void 0 ? void 0 : _a.call(opts, result, currentData); }
                    : undefined,
                revalidate: !(opts === null || opts === void 0 ? void 0 : opts.populateCache),
                throwOnError: !(opts === null || opts === void 0 ? void 0 : opts.onError),
                onSuccess: (data) => {
                    var _a, _b;
                    (_a = opts === null || opts === void 0 ? void 0 : opts.onSuccess) === null || _a === void 0 ? void 0 : _a.call(opts, data);
                    (_b = opts === null || opts === void 0 ? void 0 : opts.finally) === null || _b === void 0 ? void 0 : _b.call(opts);
                },
                onError: (error) => {
                    var _a, _b;
                    (_a = opts === null || opts === void 0 ? void 0 : opts.onError) === null || _a === void 0 ? void 0 : _a.call(opts, error);
                    (_b = opts === null || opts === void 0 ? void 0 : opts.finally) === null || _b === void 0 ? void 0 : _b.call(opts);
                }
            });
            // Revalidate specified keys
            if ((opts === null || opts === void 0 ? void 0 : opts.revalidateKeys) && opts.revalidateKeys.length > 0) {
                mutate((key) => { var _a; return typeof key === 'string' && ((_a = opts.revalidateKeys) === null || _a === void 0 ? void 0 : _a.includes(key)); }, undefined, { revalidate: true });
            }
            return data;
        }
    };
};
//# sourceMappingURL=useMutation.js.map